
import Vue from 'vue'
import PaymentMethodCreditCard from './PaymentMethodCreditCard.vue'
import PaymentMethodSchoolCharge from './PaymentMethodSchoolCharge.vue'
import PaymentMethodCreditCardIcons from './PaymentMethodCreditCardIcons.vue'
import SelectionAccordion, { SelectionAccordionOption } from '../SelectionAccordion.vue'
import { Currency } from '@/components'

export default Vue.extend({
   name: 'PaymentType',
   data() {
      return {
         working: false,
      }
   },
   computed: {
      paymentType(): string {
         return this.isSchoolInvoicing ? 'invoice' : 'creditcard'
      },
      schoolInvoicingOptionVisible(): boolean {
         return this.schoolInvoicingAllowed && this.isSchoolOrder
      },
      schoolInvoicingAllowed(): boolean {
         return this.$store.getters.schoolAllowsInvoicing
      },
      hasSchool(): boolean {
         return this.$store.state.purchase.schoolId!!
      },
      paymentRequired(): boolean {
         return this.$store.getters.requiresPayment
      },
      paymentTypeOptions(): SelectionAccordionOption[] {
         return [
            {
               name: 'Credit Card',
               value: 'creditcard',
               component: PaymentMethodCreditCard,
               infoComponent: PaymentMethodCreditCardIcons,
            },
            {
               name: 'Invoice my school',
               value: 'invoice',
               disabled: !this.hasSchool,
               component: PaymentMethodSchoolCharge,
            },
         ]
      },
      isSchoolInvoicing(): boolean {
         return this.$store.state.purchase.IsSchoolInvoicing
      },
      isSchoolOrder(): boolean {
         return !this.$store.state.purchase.IsPersonalOrder
      },
      useStoreCredit(): boolean {
         return this.$store.state.purchase.UseStoreCredit
      },
      hasStoreCreditAvailable(): boolean {
         return this.$store.state.modelData.HasStoreCreditAvailable
      },
      storeCreditAvailable(): number {
         return this.$store.state.modelData.StoreCreditAvailable
      },
   },
   methods: {
      setOption(option: string) {
         this.setPaymentType(option === 'invoice')
      },
      setPaymentType(isSchoolInvoicing: boolean) {
         this.$store.dispatch('setPaymentMethod', isSchoolInvoicing)
      },
      async updateUseStoreCredit(value: any) {
         this.working = true
         await this.$store.dispatch('setUseStoreCredit', !this.useStoreCredit)
         this.working = false
      },
   },
   components: {
      Currency,
      SelectionAccordion,
      PaymentMethodCreditCard,
   },
})
